/** Selector de período predefinido (mismos keys que el módulo Leads / GAS). */
export default function DateRangeFilter({ id, value, options, disabled, onChange, label = 'Período' }) {
  return (
    <label className="analytics-field" htmlFor={id}>
      <span>{label}</span>
      <select id={id} value={value} disabled={disabled} onChange={(e) => onChange(e.target.value)}>
        {(options || []).map((o) => (
          <option key={o.key} value={o.key}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
